/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : MultiselectConnectorV2.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useEffect, useState } from "react";
import CustomMultiSelectV2 from "../multiselect/CustomMultiSelectV2";

function MultiselectConnectorV2({
  selectedValues = [],
  setSelectedValues,
  optionsList = [],
  required,
  label,
  txtFldStyle = {},
  renderOption,
  getOptionLabel,
  disabled,
  height,
  placeholder,
  immutableValues = [],
}) {
  const [convertedSelectedValues, setConvertedSelectedValue] = useState([]);

  // Sync local state from parent only when parent values change
  useEffect(() => {
    // Derive the corresponding objects
    const mapped = optionsList.filter((el) =>
      selectedValues.includes(el.value)
    );

    // Only update local state if something actually changed
    if (
      mapped.length !== convertedSelectedValues.length ||
      mapped.some(
        (el) => !convertedSelectedValues.find((x) => x.value === el.value)
      )
    ) {
      setConvertedSelectedValue(mapped);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValues, optionsList]);

  // Handle selection changes (update parent directly)
  const handleChange = (newSelectedObjects) => {
    const immutableSet = new Set(immutableValues.map(String));

    // Ensure immutable values are present in selection
    const correctedObjects = (() => {
      const currentSet = new Set(newSelectedObjects.map((o) => String(o.value)));
      const missingImmutable = optionsList.filter(
        (opt) => immutableSet.has(String(opt.value)) && !currentSet.has(String(opt.value))
      );
      return [...newSelectedObjects, ...missingImmutable];
    })();

    setConvertedSelectedValue(correctedObjects);
    const valueArray = correctedObjects.map((el) => el.value);

    if (
      valueArray.length !== selectedValues.length ||
      valueArray.some((val) => !selectedValues.includes(val))
    ) {
      setSelectedValues(valueArray);
    }
  };

  return (
    <CustomMultiSelectV2
      required={required}
      label={label}
      optionsList={optionsList}
      selectedValues={convertedSelectedValues || " "}
      setSelectedValues={handleChange}
      txtFldStyle={txtFldStyle}
      renderOption={renderOption}
      getOptionLabel={getOptionLabel}
      disabled={disabled}
      height={height}
      placeholder={placeholder}
    />
  );
}

export default MultiselectConnectorV2;
